<template>
  <div class="text-center mx-auto">
    <h1>Editando matricula</h1>
    <v-divider></v-divider>
    <FormEnrolment
      :enrolment="enrolment"
      :is-new="false"
      @submitEnrolment="editEnrolment($event)"
    ></FormEnrolment>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AdminEnrolmentService from '@/services/admin-enrolment/admin-enrolment.service';
import FormEnrolment from '@/pages/admin/components/user/FormEnrolment';
import Enrolment from '@/models/enrolment';

const enrolmentService = new AdminEnrolmentService();

export default {
  name: 'EditEnrolment',
  components: { FormEnrolment },
  data: () => ({
    userId: null,
    enrolment: new Enrolment(),
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
    this.userId = this.$route.params?.userId ?? null;
    const enrolmentId = this.$route.params?.enrolmentId ?? null;

    if (this.userId === null || enrolmentId === null) {
      this.$router.push('/');
      return;
    }

    this.enrolment.user = this.userId;

    enrolmentService.get(enrolmentId)
      .then((response) => {
        this.enrolment.id = response.data.id;
        this.enrolment.user = response.data.user.id;
        this.enrolment.course = response.data.course.id;
        this.enrolment.type = response.data.type;
        this.enrolment.setAccessLimit(new Date(response.data.accessLimit));
      })
      .catch(console.error);
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    editEnrolment(enrolment) {
      this.loading = true;

      enrolmentService.update(enrolment)
        .then((response) => {
          this.showSnack(response.data.message);

          this.loading = false;
          this.$router.push(`/admin/user/${this.userId}/enrolments`);
        })
        .catch((err) => {
          this.loading = false;
          this.showSnack(err?.response?.data?.message ?? 'Falha ao atualizar matricula');
        });
    },
  }
};
</script>

<style scoped>

</style>
